import { use_slice_search, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { md } from '@/utils/utils_html';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { SSearchHistoryListItem } from './SSearchHistoryListItem';

export function SSearchHistoryList() {
  const { search_history_map, search_current } = use_slice_search(['search_history_map', 'search_current']);
  const { page_search_hide_unused } = use_slice_ui(['page_search_hide_unused']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const need_show_item = (item: DTOSearchSettings) => {
    let out = true;

    if (workspace_current._id != item.workspace_id) {
      out = false;
    } else if (search_current._id == item._id) {
      out = true;
    } else if (page_search_hide_unused) {
      out = !item.is_hidden;
    }

    return out;
  };

  return (
    <div className={`flex flex-col w-full h-full bg-component overflow-auto   ${md(' max-h-full min-h-full rounded-lg', 'p-2 rounded-b-lg')}`}>
      {Array.from(search_history_map.values())
        .filter(need_show_item)
        .sort(DTOSearchSettings.sort)
        .map(item => (
          <SSearchHistoryListItem key={item._id} item={item} />
        ))}
    </div>
  );
}
